import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 8h18","key":"svg-0"}],["path",{"d":"M3 16h18","key":"svg-1"}],["path",{"d":"M8 3v18","key":"svg-2"}],["path",{"d":"M16 3v18","key":"svg-3"}]]

const IconGrid3x3 = createReactComponent('outline', 'grid-3x3', 'Grid3x3', __iconNode);

export default IconGrid3x3;